import { render, staticRenderFns } from "./BirdEye.vue?vue&type=template&id=8094b060&scoped=true"
import script from "./BirdEye.vue?vue&type=script&lang=js"
export * from "./BirdEye.vue?vue&type=script&lang=js"
import style0 from "./BirdEye.vue?vue&type=style&index=0&id=8094b060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8094b060",
  null
  
)

export default component.exports